import cloneDeep from 'lodash.clonedeep';
// Services
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/services/folderable-collection-service-base.service";
const OWNER_OPTIONS = [
    {
        label: 'Me',
        value: 'me',
        checked: true,
    },
    {
        label: 'Shared with me',
        value: 'shared_with_me',
        checked: true,
    },
];
const OWNER_PUBLIC_OPTION = {
    label: 'Public',
    value: 'public',
    checked: true,
};
const INCLUDE_EMPTY_FOLDERS_FILTER = [
    {
        label: 'Show empty folders',
        value: 'includeEmptyFolders',
        checked: true,
    },
];
export class FolderableOpenSavedFilterDirective {
    constructor(folderableCollectionService) {
        this.folderableCollectionService = folderableCollectionService;
    }
    ngOnInit() {
        this.ownerOptions = OWNER_OPTIONS;
        if (this.publicSharing) {
            this.ownerOptions.push(OWNER_PUBLIC_OPTION);
        }
        this.includeEmptyFoldersFilter = INCLUDE_EMPTY_FOLDERS_FILTER;
        if (this.folderableCollectionService.dataParams) {
            // if available, initialize ownerOptions based on dataParams as they should reflect
            // the user's current filter preferences
            this.mapStateToOwnerOptions(this.folderableCollectionService.dataParams.owner);
            this.searchTerm = this.folderableCollectionService.dataParams.name;
            this.includeEmptyFoldersFilter[0].checked =
                this.folderableCollectionService.dataParams.includeEmptyFolders ?? true;
        }
        this.folderableCollectionSubscription = this.folderableCollectionService.viewResponse$.subscribe((response) => {
            if (response === null)
                return;
            this.searchTerm = response.params.name;
            this.mapStateToOwnerOptions(response.params.owner);
            this.includeEmptyFoldersFilter[0].checked = response.params.includeEmptyFolders ?? true;
        });
    }
    ngOnDestroy() {
        this.folderableCollectionSubscription.unsubscribe();
    }
    mapStateToOwnerOptions(filter) {
        this.ownerOptions = this.ownerOptions.map((option) => {
            return {
                ...option,
                checked: filter[option.value],
            };
        });
    }
    setOwner(checkBoxResults) {
        const params = cloneDeep(this.folderableCollectionService.dataParams);
        params.owner = checkBoxResults;
        this.folderableCollectionService.refreshData(params);
    }
    setIncludeEmptyFolders(checkBoxResults) {
        const params = cloneDeep(this.folderableCollectionService.dataParams);
        params.includeEmptyFolders = checkBoxResults.includeEmptyFolders;
        this.folderableCollectionService.refreshData(params);
    }
    setSearchTerm() {
        if (this.searchTerm === this.folderableCollectionService.dataParams.name)
            return;
        const params = cloneDeep(this.folderableCollectionService.dataParams);
        params.name = this.searchTerm;
        this.folderableCollectionService.refreshData(params);
    }
}
FolderableOpenSavedFilterDirective.ɵfac = function FolderableOpenSavedFilterDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableOpenSavedFilterDirective)(i0.ɵɵdirectiveInject(i1.FolderableCollectionServiceBase)); };
FolderableOpenSavedFilterDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FolderableOpenSavedFilterDirective });
